import { defineMessages } from 'react-intl';

export default defineMessages({
	checkYourEmail: {
		defaultMessage: 'Check your email to reset your password',
		description: 'Help text to tell user check their mailbox for reset password email',
		id: 'cv.login.forgot.password.check.your.email',
	},
	emailHasBeenSentMessage: {
		defaultMessage: "We've sent a reset password link to {emailAddress}",
		description: 'A help text to inform the user that email has been sent',
		id: 'cv.login.forgot.password.email.has.been.sent',
	},
	resendResetPasswordLinkLabel: {
		defaultMessage: 'Resend reset password link',
		description: 'label for Resend reset password link button',
		id: 'cv.login.forgot.password.resend.button.label',
	},
	resendSuccessMessage: {
		defaultMessage: 'Email sent to {emailAddress}',
		description:
			'Success notification confirming the reset password email was sent to {emailAddress}',
		id: 'cv.login.forgot.password.resend.success.flag.message',
	},
});
